export default {
    "serviceOptionCode": "21",
    "planNumber": "805222",
    "serviceOptionName": "Monthly Performance Emails",
    "serviceStatusCode": "G",
    "commProcessCode": "    ",
    "serviceEnrollDate": "2023-05-18"
}
